// extracted by mini-css-extract-plugin
export default {"root":"TimeTable_root__hpqtx","day":"TimeTable_day__-j08J","time":"TimeTable_time__aJaQB","highlight":"TimeTable_highlight__TwaJ6"};